'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import { useEffect, useState } from 'react';

const useMediaQuery = (query, defaultValue = false) => {
    const [matches, setMatches] = useState(defaultValue);

    useEffect(() => {
        let performingCleanup = false;

        const mediaQueryList = window.matchMedia(query);
        setMatches(!!mediaQueryList.matches);

        const handleChange = () => {
            if (performingCleanup) {
                return;
            }
            setMatches(!!mediaQueryList.matches);
        };

        mediaQueryList.addListener(handleChange);

        return () => {
            performingCleanup = true;
            mediaQueryList.removeListener(handleChange);
        };
    }, [query]);

    return matches;
};

export default useMediaQuery;
